import { useTranslation } from 'react-i18next';
import useConfigurationStore from '../store/configurationStore';
import { formatPrice } from '../utils/priceCalculator';

export default function PriceSidebar() {
    const { t } = useTranslation();
    const { priceBreakdown, selectedOptions, categories, optionsByCategory } = useConfigurationStore();
    const config = window.astConfig || {};

    if (!config.showPrices) {
        return (
            <aside className="ast-price-sidebar">
                <div className="ast-price-sidebar__card">
                    <h3>{t('wizard.summary')}</h3>
                    <p className="ast-price-sidebar__count">
                        {Object.keys(selectedOptions).length} opties geselecteerd
                    </p>
                    <button className="ast-btn ast-btn--primary ast-btn--full">
                        {t('price.requestQuote')}
                    </button>
                </div>
            </aside>
        );
    }

    // Group selected options by category for display.
    const groupedSelections = {};
    categories.forEach((cat) => {
        const catOptions = (optionsByCategory[cat.id] || []).filter(
            (opt) => selectedOptions[opt.id]
        );
        if (catOptions.length > 0) {
            groupedSelections[cat.name] = catOptions;
        }
    });

    return (
        <aside className="ast-price-sidebar">
            <div className="ast-price-sidebar__card">
                <h3>{t('wizard.summary')}</h3>

                <div className="ast-price-sidebar__items">
                    {Object.entries(groupedSelections).map(([catName, opts]) => (
                        <div key={catName} className="ast-price-sidebar__group">
                            <h5 className="ast-price-sidebar__cat">{catName}</h5>
                            {opts.map((opt) => {
                                const sel = selectedOptions[opt.id];
                                const line = priceBreakdown.lines?.find(
                                    (l) => Number(l.option_id) === Number(opt.id)
                                );
                                return (
                                    <div key={opt.id} className="ast-price-sidebar__line">
                                        <span className="ast-price-sidebar__name">
                                            {opt.name}
                                            {sel?.quantity > 1 && ` (${sel.quantity}x)`}
                                        </span>
                                        <span className="ast-price-sidebar__amount">
                                            {line?.priceNone ? (
                                                ''
                                            ) : line?.priceOnRequest ? (
                                                <span className="ast-price-on-request">Nacalculatie</span>
                                            ) : line?.priceIncluded ? (
                                                <span className="ast-price-included">Inbegr.</span>
                                            ) : (
                                                formatPrice(line?.lineTotal || 0)
                                            )}
                                        </span>
                                    </div>
                                );
                            })}
                        </div>
                    ))}
                </div>

                <div className="ast-price-sidebar__totals">
                    <div className="ast-price-sidebar__row">
                        <span>{t('price.subtotal')}</span>
                        <span>{formatPrice(priceBreakdown.subtotal)}</span>
                    </div>
                    <div className="ast-price-sidebar__row ast-price-sidebar__row--muted">
                        <span>{t('price.vat')} ({priceBreakdown.vatPercentage}%)</span>
                        <span>{formatPrice(priceBreakdown.vatAmount)}</span>
                    </div>
                    <div className="ast-price-sidebar__row ast-price-sidebar__row--total">
                        <span>{t('price.total')}</span>
                        <span>{formatPrice(priceBreakdown.total)}</span>
                    </div>
                </div>
            </div>
        </aside>
    );
}
